<template lang="pug">
div(:class="$style.headerCards")
  CategoryCard(
    title="Home removals"
    link-path="/instant-prices/house-move/listing-items"
    image-peeks-out
    animate-from="bottom"
    @cardClick="trackCardClick"
    :instant-prices="true"
  )
    figure(:class="[$style.largeLoadingPlaceholder, 'flex justify-center items-center']")
      img(
        src="~/assets/img/homepage/removals_variant_1x.webp"
        srcset="~/assets/img/homepage/removals_variant_2x.webp 2x"
        alt="Home removals"
        style="--image-width: 420px; --image-height: 370px;"
      )
  CategoryCard(
    id="furniture-card"
    title="Furniture"
    link-path="/courier-services/furniture-couriers"
    image-peeks-out
    animate-from="bottom"
    @cardClick="trackCardClick"
    :instant-prices="true"
  )
    figure(:class="[$style.largeLoadingPlaceholder, 'flex justify-center items-center']")
      img(
        src="~/assets/img/homepage/furniture_variant_1x.webp"
        srcset="~/assets/img/homepage/furniture_variant_2x.webp 2x"
        alt="Furniture removal"
        style="--image-width: 420px; --image-height: 370px;"
      )
  CategoryCard(
    title="Cars"
    link-path="/instant-prices/car/listing-items"
    @cardClick="trackCardClick"
    :instant-prices="true"
  )
    figure(:class="[$style.smallLoadingPlaceholder, 'flex justify-center items-center']")
      img(
        src="~/assets/img/homepage/cars-2.webp"
        alt="car transport"
        style="--image-width: 272px; --image-height: 215px;"
      )
  CategoryCard(
    title="Storage"
    link-path="/storage"
    @cardClick="trackCardClick"
  )
    figure(:class="[$style.smallLoadingPlaceholder, 'flex justify-center items-center']")
      img(
        src="~/assets/img/homepage/storage_1x.webp"
        srcset="~/assets/img/homepage/storage_2x.webp 2x"
        alt="storage moves"
        style="--image-width: 272px; --image-height: 215px;"
      )
  CategoryCard(
    title="Other"
    link-path="/categories"
    @cardClick="trackCardClick"
    :instant-prices="true"
  )
    figure(:class="[$style.smallLoadingPlaceholder, 'flex justify-center items-center']")
      img(
        src="~/assets/img/homepage/other.webp"
        alt="transport services"
        style="--image-width: 272px; --image-height: 215px;"
      )
</template>

<script lang="ts">
import { defineComponent } from "vue"
import { mapGetters } from "vuex"
import { GET_IS_SMALL_OR_MEDIUM } from "~/store/pages"

export default defineComponent({
  name: "HeaderCards",
  computed: {
    ...mapGetters("pages", {
      isMobile: GET_IS_SMALL_OR_MEDIUM
    })
  },
  mounted() {
    if (!this.isMobile) {
      // The <a> href attribute is not reactive in Nuxt2 so we need this workaround.
      const furnitureCard = document.getElementById("furniture-card")
      if (furnitureCard) {
        furnitureCard.setAttribute("href", "/instant-prices/furniture/listing-items")
      }
    }
  },
  methods: {
    trackCardClick(title: string) {
      this.$snowplow.trackCategoryCardClick(title)
    }
  }
})
</script>

<style module lang="css">
.headerCards {
  @apply grid gap-ds-md md:gap-ds-ml;
  display: grid;
  grid-auto-rows: min-content;
  grid-template-rows: auto auto; /* Two rows */
  grid-template-columns: repeat(6, 1fr); /* First row with two equal columns */

  /* Explicitly place the first two children in the first row */

  > :nth-child(1) {
    grid-column: 1 / 4;
  }

  > :nth-child(2) {
    grid-column: 4 / 7;
  }

  > :nth-child(3) {
    grid-column: 1 / 3;
  }

  > :nth-child(4) {
    grid-column: 3 / 5;
  }

  > :nth-child(5) {
    grid-column: 5 / 7;
  }

  .largeLoadingPlaceholder {
    aspect-ratio: 42 / 37; /* Fixes layout shift prior to images loading */
  }

  .smallLoadingPlaceholder {
    aspect-ratio: 272 / 215; /* Fixes layout shift prior to images loading */
  }
}
</style>
